import { FeatureType } from "interfaces/feature-tracker";
import { baseApi } from "../api";

const featureType = FeatureType.REBATE_OFFER;

export const rebateOfferAPI = baseApi.injectEndpoints({
	endpoints: (builder) => ({
		simulateContributionsRebate: builder.mutation({
			query: (arg) => {
				const queryParams = new URLSearchParams();
				for (const key in arg.body) {
					queryParams.append(key, arg.body[key]);
				}
				return {
					url: `rest/debug/rebate/contribute?${queryParams.toString()}`,
					method: "POST"
				};
			},
			invalidatesTags: () => [{ type: "featureTrackerTag", id: featureType }]
		})
	})
});

export const { useSimulateContributionsRebateMutation } = rebateOfferAPI;
